export default "__VITE_ASSET__7cc04f12__"